module.exports = __webpack_public_path__ + "media/vizilo_m.620cc9ac.mp3";